import { render } from "./TakeOutProductCollection.vue?vue&type=template&id=5127f9fa&scoped=true"
import script from "./TakeOutProductCollection.vue?vue&type=script&lang=js"
export * from "./TakeOutProductCollection.vue?vue&type=script&lang=js"

import "./TakeOutProductCollection.vue?vue&type=style&index=0&id=5127f9fa&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5127f9fa"]])

export default __exports__